/* ============
 * All Packaging Types
 * ============
 *
 * All packaging types from a product.
 */

import Vue from 'vue';
import store from '../../store';
import unitTypeTransformer from '../../transformers/unitType';

const success = ({ data }, resolve) => {
  const unitTypes = unitTypeTransformer.fetchCollection(data.data);

  store.dispatch('fetchUnitTypes', unitTypes);
  resolve();
};

const failed = () => {
};

// Display packaging types related to a product.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('unit_types')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/unitType/all.js